import React, { useEffect } from "react";
import PropTypes from 'prop-types';
import { Heading, Button } from "@lmig/lmds-react";
import useMeasure from '@lmig/dotcom-aspect-hooks/useMeasure';
import css from 'styled-jsx/css';
import { Maps } from "../Google/DynamicExports";

const OfficeMap = ({ office }) => {
  const [{ ref }, { height: mapHeight }] = useMeasure();
  useEffect(() => {
    ref.current = document.querySelector(".officeMap .map");
  }, [ref]);

  const { className: headingClass, styles: headingStyles } = css.resolve`
    *{
      color: #1a1446;
      font-size: 1.5rem;
      line-height: 1.33;

      @media screen and (min-width: 48rem) {
        font-size: 2rem;
        line-height: 1.25;
      }
    }
  `;

  return (
    <div className="officeMap">
      <div className="officeMapWrapper">
        <div className="information">
          <Heading type="h2-bold" className={headingClass}>About Comparion Insurance Agency in {office.address.city}, {office.address.state.code}</Heading>
          <div className="description">
            Local sales agents serving customers in {office.address.city}, {office.address.state.code}.
            We're launching Comparion Insurance Agency: A Liberty Mutual Company to help consumers and small businesses get the expert advice they need to find the right insurance policy.
            Comparion agents will help you find personalized coverage to fit your budget - offering options from many national and regional insurance companies.
          </div>
          <div data-theme="evolved"><Button href="/about-us">Learn more about us</Button></div>
        </div>
        <div className="map">
          <Maps
            height={`${mapHeight}px`}
            markers={[{
              lat: office.location.coordinates[1],
              lng: office.location.coordinates[0],
            }]}
            useCustomMarker={false}
          />
        </div>
      </div>
      {headingStyles}
      <style jsx>{`
        .officeMap {
          background-color: #f2fcfc;
          position: relative;
        }
        .officeMapWrapper {
          max-width: 80rem;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          align-items: start;

          @media screen and (min-width: 48rem) {
            padding: 3rem 2rem 2rem 2rem;
          }
        }
        .officeMapWrapper {
          @media screen and (min-width: 64rem) {
            flex-direction: row;
            padding: 0;
          }
        }
        .information {
          width: 100%;
          padding: 0 1rem;
          text-align: center;
          padding-bottom: 2rem;
          order: 2;
          
          @media screen and (min-width: 48rem) {
            text-align: left;
          }
        }
        .information {
          @media screen and (min-width: 64rem) {
            max-width: 50%;
            padding-right: 2rem;
            padding-left: 4rem;
            order: 0;
          }
        }
        .map {
          width: 100%;
          display: none;

          @media screen and (min-width: 48rem) {
            display: block;
          }
        }
        .map {
          @media screen and (min-width: 64rem) {
            max-width: 50%;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 50%;
            right: 0;
            height: 100%;
          }
        }
        .description {
          margin: -0.5rem 0 1.5rem 0;
          text-align: left;
        }
      `}</style>
    </div >
  );
};

OfficeMap.propTypes = {
  office: PropTypes.shape({
    address: PropTypes.shape({
      city: PropTypes.string.isRequired,
      state: PropTypes.shape({
        name: PropTypes.string.isRequired,
        code: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    location: PropTypes.shape({
      coordinates: PropTypes.arrayOf(PropTypes.number).isRequired
    }).isRequired
  }).isRequired
};

export default OfficeMap;
